module.exports = {"id":"181456","name":"Romain Genevois","rating":"73","photo":"./data/images/photos/4/181456.png","club":{"name":"SM Caen","logo":"./data/images/clubs/SMCaen.png"},"positions":["DC","DD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RomainGenevois0.json
// module id = 3686
// module chunks = 0